import { memo } from 'react';

import { CLOSET_VALUE, LED_MIRRORS_VALUE, MIRROR_CABINETS_VALUE, PEDESTAL_VALUE } from '@shared/constants/catalog';
import { ProductCardType } from '@shared/types/product';
import { formatPrice } from '@shared/utils/formatPrice/formatPrice';
import { YandexSplitBadge } from '@widgets/ProductCard/ui/CardVariant/YandexSplitBadge/YandexSplitBadge';
import { ProductReviewsSummary } from '@widgets/ProductReviewsSummary';

import cls from './Info.module.scss';

type InfoProps = {
  data: ProductCardType;
};

export const Info = memo(({ data }: InfoProps) => {
  const {
    name,
    seoName,
    category,
    bodyMaterial,
    price,
    subCategory,
    antifogMirror,
    switchType,
    mirrorShape,
    bodyColor,
    color,
    storageSystem,
    backlight,
    rating
  } = data;

  const isPedestalOrCloset = [PEDESTAL_VALUE, CLOSET_VALUE].includes(category);
  const isLedMirror = subCategory === LED_MIRRORS_VALUE;
  const isMirrorCabinets = subCategory === MIRROR_CABINETS_VALUE;

  return (
    <div className={cls.wrap}>
      <YandexSplitBadge
        className={'splitBadge'}
        {...{ price }}
      />
      <div className={cls.price}>{formatPrice(price)}</div>
      <div className={cls.title}>{seoName || name}</div>
      <ProductReviewsSummary
        className={cls.reviewsSummary}
        rating={rating}
      />
      <div className={cls.chars}>
        {isLedMirror && switchType && (
          <div className={cls.char}>
            <div className={cls.label}>Тип выключателя:</div>
            <div className={cls.value}>{switchType}</div>
          </div>
        )}
        {(isLedMirror || isMirrorCabinets) && mirrorShape && (
          <div className={cls.char}>
            <div className={cls.label}>Форма зеркала:</div>
            <div className={cls.value}>{mirrorShape}</div>
          </div>
        )}
        {isLedMirror && antifogMirror && (
          <div className={cls.char}>
            <div className={cls.label}>Зеркало с антизапотевателем (с дефоггером):</div>
            <div className={cls.value}>{antifogMirror === 'true' ? 'Да' : 'Нет'}</div>
          </div>
        )}
        {isMirrorCabinets && backlight && (
          <div className={cls.char}>
            <div className={cls.label}>Подсветка:</div>
            <div className={cls.value}>{backlight === 'true' ? 'Да' : 'Нет'}</div>
          </div>
        )}
        {isPedestalOrCloset && bodyColor && (
          <div className={cls.char}>
            <div className={cls.label}>Цвет корпуса:</div>
            <div className={cls.value}>{bodyColor}</div>
          </div>
        )}
        {isPedestalOrCloset && color && (
          <div className={cls.char}>
            <div className={cls.label}>Цвет мебели:</div>
            <div className={cls.value}>{color.value}</div>
          </div>
        )}
        {(isPedestalOrCloset || isMirrorCabinets) && bodyMaterial && (
          <div className={cls.char}>
            <div className={cls.label}>Материал корпуса:</div>
            <div className={cls.value}>{bodyMaterial.value}</div>
          </div>
        )}
        {isPedestalOrCloset && storageSystem && (
          <div className={cls.char}>
            <div className={cls.label}>Система хранения:</div>
            <div className={cls.value}>{storageSystem}</div>
          </div>
        )}
      </div>
    </div>
  );
});
